import React, { createContext } from "react";

import { Media } from "../types/player-api";

export const MediaContext = createContext<Media | undefined>(undefined);

export const useMediaContext = () => {
  const context = React.useContext(MediaContext);
  if (context === undefined) {
    throw new Error("MediaContext not found");
  }
  return context;
};
